<script setup>
import { OhVueIcon } from 'oh-vue-icons';
import { storeToRefs } from 'pinia';

import { useSectionStore } from '@/store/sections';
import TranslationValue from '@/components/layouts/TranslationValue.ce.vue';
import {join} from "lodash-es";

const sectionStore = useSectionStore();
const { current, nextButtonEnabled } = storeToRefs(sectionStore);
const { nextSection, previousSection } = sectionStore;

const buttonCss = {
    layout: [
        'flex flex-row font-medium rounded-lg text-sm px-5 py-2.5 text-center',
    ],
    lookAndFeel: [
        'text-white bg-wageindicator-orange ',
        'border border-1 border-wageindicator-orange',
        'hover:bg-wageindicator-orange-600',
        'focus:ring-4 focus:outline-none focus:ring-blue-300',
    ],
    disabled: [
        'bg-white text-blue-400 cursor-not-allowed border border-1 border-blue-700 ',
    ],
}

function getButtonCss() {
    return join(buttonCss.layout.concat(buttonCss.lookAndFeel), ' ')
}

function getDisabledButtonCss() {
    return join(buttonCss.layout.concat(buttonCss.disabled), ' ')

}

function nextCssClass() {
    if (nextButtonEnabled.value) {
        return getButtonCss();
    }
    return getDisabledButtonCss();
}
</script>

<template>
    <div class="grid grid-cols-2 mt-4">
        <div>
            <button
                v-if="current > 1"
                type="button"
                :class="getButtonCss()"
                @click="previousSection()"
            >
                <span class="mr-2">
                    <OhVueIcon name="hi-chevron-left" />
                </span>
                <TranslationValue id="page2_previous" />
            </button>
        </div>

        <div class="flex justify-end">
            <button
                v-if="current !== 3"
                type="button"
                :class="nextCssClass()"
                :disabled="nextButtonEnabled === false"
                @click="nextSection()"
            >
                <template v-if="current === 1">
                    <TranslationValue id="page1_go_to_ltt" />
                </template>
                <template v-else>
                    <TranslationValue id="page2_next" />
                </template>
                <span class="ml-2">
                    <OhVueIcon name="hi-chevron-right" />
                </span>
            </button>
        </div>
    </div>
</template>
